import React, { useEffect, useState } from "react";
import styles from "./age-restriction.module.css";
import { useTranslation } from "react-i18next";
import { useAnalytics, useLocalStorage } from "@commons-monorepo/index";
import { AGE_RESTRICTION_EVENTS } from "~/components/age-restriction/events";
import { avatarProfile } from "~/assets/svg";
import { useOutletContext, useSearchParams } from "@remix-run/react";

export const AgeRestriction = ({
  cover,
  profilePic,
  isEnabled,
  name,
  age






}: {cover: string;profilePic: string;isEnabled: boolean;name: string;age: string;}) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(false);
  const key = `ageRestriction-${name}`;
  const [hasBeenChecked, setHasBeenChecked] = useLocalStorage(key, false);
  const isInPreview = !!searchParams.get("previewAgeRestriction");

  const handleCheck = () => {
    setChecked((c) => !c);
  };

  const handleAccept = () => {
    setShow(false);
    setHasBeenChecked(true);
    document.body.classList.remove("block-scroll");
    logEvent(AGE_RESTRICTION_EVENTS.select_button, {
      user_type: "buyer",
      platform: "web",
      event_subtype: "age_restriction"
    });
  };

  useEffect(() => {
    if (isEnabled && !hasBeenChecked) {
      document.body.classList.add("block-scroll");
      setShow(true);
    }
  }, [hasBeenChecked]);

  useEffect(() => {
    if (isEnabled && show) {
      logEvent(AGE_RESTRICTION_EVENTS.view_screen, {
        user_type: "buyer",
        platform: "web",
        event_subtype: "age_restriction"
      });
    }
  }, [show]);

  useEffect(() => {
    if (checked) {
      logEvent(AGE_RESTRICTION_EVENTS.select_checkbox, {
        user_type: "buyer",
        platform: "web",
        event_subtype: "age_restriction"
      });
    }
  }, [checked]);

  return (
    <div
      className={`${styles.ageRestriction} ${show && styles.visible}`}
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.84)), url(${cover})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      }}>

      <div className={styles.content}>
        <img src={profilePic || avatarProfile} />
        <h3>{t("ageRestriction.title")}</h3>
        <p>{t("ageRestriction.description")}</p>
        <div className={styles.accept}>
          <input type='checkbox' onClick={handleCheck} />
          <label>{t("ageRestriction.yes").replace("{{age}}", age)}</label>
        </div>
        <button disabled={!checked || isInPreview} onClick={handleAccept}>
          {t("ageRestriction.accept")}
        </button>
      </div>
    </div>);

};